module.exports = __webpack_public_path__ + "img/IMG_3122.3e393781.jpg";